import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "shortform-sign-up__partition" }
const _hoisted_2 = { class: "shortform-sign-up__partition-text d-md-none" }


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthPartition',
  props: {
    mobileText: { default: 'Sign in with' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "shortform-sign-up__partition-text d-none d-md-block" }, "Or", -1)),
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.mobileText), 1)
  ]))
}
}

})